import React from 'react';
import AdPage from "../components/AdPage";
import "../index.css";
const Home = () => {
    return (
        <div className='app__home'>
            <AdPage/>
        </div>
    );
};

export default Home;